<template>
  <div class="page-container">
    <div class="main-content">
      <div class="page-inner-box learn-header">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
          <el-breadcrumb-item to="/courses">所有课程</el-breadcrumb-item>
          <el-breadcrumb-item>课程购买</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div class="page-inner-box learn-content">
        <div class="product-intro">
          <div class="preview-wrap">
            <div class="main-img">
              <img :src="currentImage" alt="Product Image">
            </div>
          </div>
          
          <div class="item-info">
            <h1 class="item-title">{{ product.title }}</h1>
            
            <div class="price-panel">
              <div class="price-main">
                <span class="symbol">¥</span>
                <span class="amount">{{ product.price.toFixed(2) }}</span>
                <span class="svip-tag">SVIP</span>
                <span class="svip-price">¥ {{ product.svipPrice.toFixed(2) }}</span>
                <span class="original-price">¥{{ product.originalPrice.toFixed(2) }}</span>
              </div>
              <div class="sales-info">
                <div class="count">{{ product.sales }}</div>
                <div class="label">销量</div>
              </div>
            </div>
            
            <div class="sku-area">
              <div class="sku-row">
                <div class="sku-label">版本</div>
                <div class="sku-options">
                  <div 
                    class="sku-item" 
                    :class="{ active: selectedVersion === 'new' }"
                    @click="selectedVersion = 'new'"
                  >
                    新版
                    <i v-if="selectedVersion === 'new'" class="el-icon-check active-icon"></i>
                  </div>
                  <div 
                    class="sku-item" 
                    :class="{ active: selectedVersion === 'old' }"
                    @click="selectedVersion = 'old'"
                  >
                    旧版
                    <i v-if="selectedVersion === 'old'" class="el-icon-check active-icon"></i>
                  </div>
                </div>
              </div>
              
              <div class="sku-row">
                <div class="sku-label">包装</div>
                <div class="sku-options">
                  <div 
                    class="sku-item" 
                    :class="{ active: selectedPackage === 'normal' }"
                    @click="selectedPackage = 'normal'"
                  >
                    普通
                    <i v-if="selectedPackage === 'normal'" class="el-icon-check active-icon"></i>
                  </div>
                </div>
              </div>
              
              <div class="sku-row">
                <div class="sku-label">数量</div>
                <div class="sku-options">
                  <el-input-number v-model="quantity" :min="1" :max="product.stock" size="small"></el-input-number>
                  <span class="stock-text">库存 {{ product.stock }} 件</span>
                </div>
              </div>
            </div>
            
            <div class="action-btns">
              <el-button v-if="!product.isPurchased" class="btn-cart" type="primary" @click="addToCart">加入购物车</el-button>
              <el-button class="btn-buy" plain @click="buyNow">{{ product.isPurchased ? '立即学习' : '立即购买' }}</el-button>
            </div>
          </div>
        </div>
        
        <div class="product-detail">
          <div class="detail-header">
            <div class="tab-title">课程详情</div>
            <!-- <div class="mobile-buy">
              <i class="el-icon-mobile-phone"></i> 手机购买 <i class="el-icon-caret-bottom"></i>
            </div> -->
          </div>
          <div class="detail-content">
            <div v-if="product.introductionHtml" class="detail-rich" v-html="product.introductionHtml"></div>
            <div v-else class="detail-empty">暂无详情</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCourseDetail } from '@/api/courseApi'
import { addCartItem } from '@/api/cartApi'

const defaultProductImage = require('@/assets/image/study_placeholder.png')

export default {
  name: 'CoursePurchase',
  data() {
    return {
      product: {
        title: '',
        price: 0,
        svipPrice: 0,
        originalPrice: 0,
        sales: 0,
        stock: 1,
        isPurchased: false,
        introductionHtml: ''
      },
      currentImage: defaultProductImage,
      selectedVersion: 'new', // new, old
      selectedPackage: 'normal', // normal
      quantity: 1,
      courseId: null,
      detailLoading: false
    }
  },
  created() {
    this.init()
  },
  watch: {
    '$route.params.id': 'init'
  },
  methods: {
    init() {
      const id = this.$route && this.$route.params ? this.$route.params.id : null
      this.courseId = id
      this.fetchCourseDetail()
    },
    sanitizeUrl(val) {
      const s = String(val || '').trim()
      if (!s) return ''
      return s.replace(/\\`/g, '').replace(/`/g, '').trim()
    },
    sanitizeRichText(html) {
      const raw = String(html || '')
      if (!raw.trim()) return ''
      const cleaned = raw.replace(/\\`/g, '').replace(/`/g, '')
      try {
        const parser = new DOMParser()
        const doc = parser.parseFromString(cleaned, 'text/html')
        doc.querySelectorAll('script').forEach(node => node.remove())
        doc.querySelectorAll('*').forEach(el => {
          Array.from(el.attributes || []).forEach(attr => {
            const name = String(attr.name || '').toLowerCase()
            if (name.startsWith('on')) el.removeAttribute(attr.name)
          })
          if (el.hasAttribute('href')) {
            const href = this.sanitizeUrl(el.getAttribute('href'))
            if (/^javascript:/i.test(href)) el.removeAttribute('href')
            else el.setAttribute('href', href)
          }
          if (el.hasAttribute('src')) {
            const src = this.sanitizeUrl(el.getAttribute('src'))
            if (/^javascript:/i.test(src)) el.removeAttribute('src')
            else el.setAttribute('src', src)
          }
        })
        return doc.body.innerHTML || ''
      } catch (e) {
        return cleaned
      }
    },
    async fetchCourseDetail() {
      if (!this.courseId || this.detailLoading) return
      this.detailLoading = true
      try {
        const res = await getCourseDetail(this.courseId)
        const data = res && res.data ? res.data : null
        if (!data) return

        const coverImage = this.sanitizeUrl(data.coverImage)
        const introductionHtml = this.sanitizeRichText(data.introduction)
        const currentPrice =
          data.discountPrice != null
            ? data.discountPrice
            : (data.currentPrice != null ? data.currentPrice : (data.salePrice != null ? data.salePrice : 0))
        const originalPrice = data.salePrice != null ? data.salePrice : currentPrice
        const isPurchased = Boolean(data.isPurchased)

        this.product = {
          title: String(data.courseName || ''),
          price: Number(currentPrice || 0),
          svipPrice: Number(currentPrice || 0),
          originalPrice: Number(originalPrice || 0),
          sales: Number(data.salesCount || 0),
          stock: 1,
          isPurchased,
          introductionHtml
        }

        const main = coverImage || defaultProductImage
        this.currentImage = main
        this.quantity = 1
      } catch (err) {
        this.$message.error((err && err.message) || '获取课程详情失败')
      } finally {
        this.detailLoading = false
      }
    },
    async addToCart() {
      if (!this.$store.getters['auth/isLoggedIn']) {
        this.$message.warning('请先登录')
        this.$store.commit('auth/SET_LOGIN_VISIBLE', true)
        return
      }
      if (this.product && this.product.isPurchased) {
        this.$router.push({ name: 'learn', params: { id: this.courseId || this.$route.params.id } })
        return
      }
      
      try {
        // itemType: 1 for course
        // quantity: fixed to 1 for course
        await addCartItem(this.courseId || this.$route.params.id, 1, 1)
        this.$message.success('已加入购物车')
        window.dispatchEvent(new Event('cart-updated'))
      } catch (err) {
        this.$message.error(err.message || '加入购物车失败')
      }
    },
    buyNow() {
      if (this.product && this.product.isPurchased) {
        this.$router.push({ name: 'learn', params: { id: this.courseId || this.$route.params.id } })
        return
      }
      const courseId = this.courseId || (this.$route && this.$route.params && this.$route.params.id)
      const quantity = Number(this.quantity || 1)
      const title = this.product ? String(this.product.title || '') : ''
      const image = this.currentImage || ''
      const price = this.product ? Number(this.product.price || 0) : 0
      const totalAmount = price * quantity
      const distributorId = this.$route.query.distributorId

      const checkoutItem = {
        id: courseId,
        title,
        image,
        price,
        quantity,
        stock: this.product && this.product.stock != null ? this.product.stock : 1,
        props: [
          this.selectedVersion === 'new' ? '新版' : '旧版',
          this.selectedPackage === 'normal' ? '普通' : ''
        ].filter(Boolean),
        checked: true
      }

      try {
        localStorage.setItem('checkoutItems', JSON.stringify([checkoutItem]))
        localStorage.setItem('totalAmount', String(totalAmount))
      } catch (e) {
        void e
      }

      this.$router.push({
        name: 'payment',
        params: { id: courseId },
        query: {
          version: this.selectedVersion,
          package: this.selectedPackage,
          quantity,
          title,
          image,
          price,
          totalAmount,
          ...(distributorId ? { distributorId } : {})
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.page-container {
  min-height: 100vh;
  background-color: #f5f7fa;
  padding-top: 0;
}

.main-content {
  flex: 1;
  padding-top: 20px;
}

.page-inner-box {
  max-width: 1200px;
  margin: 0 auto;
}

.learn-header {
  padding: 12px 0;
}

.learn-content {
  margin-top: 12px;
}

.product-intro {
  background: #fff;
  padding: 20px;
  display: flex;
  gap: 30px;
  border-radius: 4px;
}

.preview-wrap {
  width: 400px;
  
  .main-img {
    width: 400px;
    height: 400px;
    border: 1px solid #eee;
    margin-bottom: 10px;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
}

.item-info {
  flex: 1;
  
  .item-title {
    font-size: 20px;
    color: #333;
    margin-bottom: 15px;
    font-weight: bold;
  }
  
  .price-panel {
    background: linear-gradient(90deg, #4034eb 0%, #7c3aed 100%);
    padding: 15px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #fff;
    margin-bottom: 20px;
    position: relative;
    overflow: hidden;
    
    /* Background circles decoration similar to screenshot */
    &::after {
      content: '';
      position: absolute;
      right: 0;
      top: 0;
      width: 100px;
      height: 100px;
      background: rgba(255,255,255,0.1);
      border-radius: 50%;
      transform: translate(30%, -30%);
    }
    
    .price-main {
      display: flex;
      align-items: baseline;
      
      .symbol {
        font-size: 16px;
      }
      
      .amount {
        font-size: 32px;
        font-weight: bold;
        margin-right: 10px;
      }
      
      .svip-tag {
        background: #000;
        color: #e6a23c;
        font-size: 12px;
        padding: 2px 4px;
        border-radius: 2px;
        margin-right: 4px;
        font-weight: bold;
      }
      
      .svip-price {
        background: #e6a23c;
        color: #000;
        font-size: 12px;
        padding: 2px 6px;
        border-radius: 2px;
        margin-right: 10px;
        font-weight: bold;
      }
      
      .original-price {
        font-size: 14px;
        text-decoration: line-through;
        opacity: 0.7;
      }
    }
    
    .sales-info {
      text-align: right;
      padding-left: 20px;
      border-left: 1px solid rgba(255,255,255,0.2);
      
      .count {
        font-size: 16px;
      }
      .label {
        font-size: 12px;
        opacity: 0.8;
      }
    }
  }
  
  .sku-area {
    margin-bottom: 30px;
    
    .sku-row {
      display: flex;
      align-items: center;
      margin-bottom: 15px;
      
      .sku-label {
        width: 60px;
        color: #999;
        font-size: 14px;
      }
      
      .sku-options {
        display: flex;
        gap: 10px;
        align-items: center;
        
        .sku-item {
          padding: 6px 20px;
          border: 1px solid #ddd;
          color: #666;
          cursor: pointer;
          position: relative;
          font-size: 14px;
          
          &.active {
            border-color: #4034eb;
            color: #4034eb;
          }
          
          .active-icon {
            position: absolute;
            bottom: 0;
            right: 0;
            background: #4034eb;
            color: #fff;
            font-size: 10px;
            padding: 1px;
          }
        }
        
        .stock-text {
          color: #999;
          font-size: 12px;
          margin-left: 10px;
        }
      }
    }
  }
  
  .action-btns {
    display: flex;
    gap: 20px;
    margin-left: 60px; /* Align with options */
    
    .btn-cart {
      background-color: #4034eb;
      border-color: #4034eb;
      width: 140px;
      height: 44px;
      font-size: 16px;
    }
    
    .btn-buy {
      width: 140px;
      height: 44px;
      font-size: 16px;
      color: #4034eb;
      border-color: #4034eb;
      background: #f0f0ff;
      
      &:hover {
        background: #e6e6ff;
      }
    }
  }
}

.product-detail {
  margin-top: 20px;
  background: #fff;
  border-radius: 4px;
  
  .detail-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 20px;
    border-bottom: 1px solid #eee;
    
    .tab-title {
      font-size: 16px;
      font-weight: bold;
      color: #333;
      border-left: 4px solid #333;
      padding-left: 10px;
    }
    
    .mobile-buy {
      color: #666;
      font-size: 14px;
      cursor: pointer;
      display: flex;
      align-items: center;
      gap: 4px;
      
      &:hover {
        color: #4034eb;
      }
    }
  }
  
  .detail-content {
    padding: 20px;

    .detail-empty {
      color: #999;
      font-size: 14px;
      text-align: center;
      padding: 30px 0;
    }

    .detail-rich {
      ::v-deep img {
        max-width: 100%;
        height: auto;
      }
    }
  }
}
</style>
